import React, { useMemo } from 'react';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import SubscribeButton from '../../../Button/SubscribeButton';
import { getDeviationSaleDetails } from '../../../utils/deviations';
export const TierButton = ({ deviation, className })=>{
    // Only show the sale if the user has an eligible discount
    const { eligibleDiscount } = useMemo(()=>getDeviationSaleDetails(deviation), [
        deviation
    ]);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, null, /*#__PURE__*/ React.createElement(SubscribeButton, {
        className: className,
        tier: deviation,
        withPrice: true,
        withSaleIndicator: !!eligibleDiscount,
        showUnsubAsView: true
    }));
};
TierButton.displayName = 'TierButton';
export default TierButton;

//# sourceMappingURL=TierButton.js.map